import { useEffect } from "react";
import "./confirm-dialog.css";

export default function ConfirmDialog({
    open,
    title,
    message,
    confirmLabel = "Confirmer",
    cancelLabel = "Annuler",
    dangerous = false,
    onConfirm,
    onCancel
}) {
    useEffect(() => {
        if (!open) {
            return undefined;
        }

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onCancel();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [open, onCancel]);

    if (!open) {
        return null;
    }

    return (
        <div className="confirm-dialog-backdrop" onClick={onCancel}>
            <div
                className="confirm-dialog card"
                role="dialog"
                aria-modal="true"
                aria-labelledby="confirm-dialog-title"
                onClick={(event) => event.stopPropagation()}
            >
                <h3 id="confirm-dialog-title">{title}</h3>
                {message && <p className="muted confirm-dialog-message">{message}</p>}
                <div className="confirm-dialog-actions">
                    <button type="button" className="btn btn-secondary btn-inline" onClick={onCancel}>
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        className={`btn btn-primary btn-inline${dangerous ? " confirm-dialog-confirm--danger" : ""}`}
                        onClick={onConfirm}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
